<template>
  <p>
    <player-link :playerId="playerId" label="игрок"/>
    (<router-link :to="{name: 'player_contests', params: {playerId: playerId}}">конкурсы</router-link>)
  </p>
</template>

<script>
import PlayerLink from './PlayerLink.vue';

export default {
  name: 'ContestPlayerInfo',

  components: {
    PlayerLink,
  },

  props: {
    contestPlayerId: {
      type: Object,
      required: true
    }
  },

  computed: {
    /** @returns {number} */
    playerId() {
      return this.contestPlayerId.playerId;
    },
  },
};
</script>
